"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStreamSLI = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _useCommonPageActionsApi = require("../../client/react/useCommonPageActionsApi");
var _useCustomPageActionApi = require("../../client/useCustomPageActionApi");
var _excluded = ["isRetry"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStreamSLI = exports.useStreamSLI = function useStreamSLI() {
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    streamStartedWorkflow = _useCommonPageActions.streamStartedWorkflow,
    streamStoppedWorkflow = _useCommonPageActions.streamStoppedWorkflow,
    startStartAllStreams = _useCommonPageActions.startStartAllStreams,
    endStartAllStreams = _useCommonPageActions.endStartAllStreams;
  var _useCustomPageActions = (0, _useCustomPageActionApi.useCustomPageActionsApi)(),
    startStreamStartLifecycle = _useCustomPageActions.startStreamStartLifecycle,
    endStreamStartLifecycle = _useCustomPageActions.endStreamStartLifecycle,
    startStreamStopLifecycle = _useCustomPageActions.startStreamStopLifecycle,
    endStreamStopLifecycle = _useCustomPageActions.endStreamStopLifecycle;

  /**
   * This function is used to start the Start Stream SLI when the Start or Start all button is clicked.
   * @param {string} streamId - The id of stream that was started
   * @returns {void}
   */
  var startStreamStartSLI = function startStreamStartSLI(_ref) {
    var _ref$isRetry = _ref.isRetry,
      isRetry = _ref$isRetry === void 0 ? false : _ref$isRetry,
      payload = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    startStreamStartLifecycle(_objectSpread(_objectSpread({}, payload), {}, {
      isRetry: isRetry
    }));
    streamStartedWorkflow(_objectSpread(_objectSpread({}, payload), {}, {
      isRetry: isRetry
    }));
  };

  /**
   * This function is used to end the Start Stream SLI when the Stream started succeeded or failed.
   * @param {string} streamId - The id of stream that was started
   * @returns {void}
   */
  var startStreamEndSLI = function startStreamEndSLI(payload) {
    endStreamStartLifecycle(payload);
  };

  /**
   * This function is used to start the Stop Stream SLI when the Stop or Stop all button is clicked.
   * @param {string} streamId - The id of Stream that was started
   * @returns {void}
   */
  var stopStreamStartSLI = function stopStreamStartSLI(payload) {
    startStreamStopLifecycle(payload);
    streamStoppedWorkflow(payload);
  };

  /**
   * This function is used to end the Stop Stream SLI when the Stream stopped succeeded or failed.
   * @param {string} streamId - The id of Stream that was started
   * @returns {void}
   */
  var stopStreamEndSLI = function stopStreamEndSLI(payload) {
    endStreamStopLifecycle(payload);
  };

  /**
   * This function is used to measure the Start All Streams duration when the Start all button is clicked.
   * @returns {void}
   */
  var startStartAllStreamsMetric = function startStartAllStreamsMetric(payload) {
    startStartAllStreams(payload);
  };

  /**
   * This function is used to measure the Start All Streams duration when the Start all button is clicked.
   * @returns {void}
   */
  var endStartAllStreamsMetric = function endStartAllStreamsMetric(payload) {
    endStartAllStreams(payload);
  };
  return {
    startStreamStartSLI: startStreamStartSLI,
    startStreamEndSLI: startStreamEndSLI,
    stopStreamStartSLI: stopStreamStartSLI,
    stopStreamEndSLI: stopStreamEndSLI,
    startStartAllStreamsMetric: startStartAllStreamsMetric,
    endStartAllStreamsMetric: endStartAllStreamsMetric
  };
};